enum AccessibilityFontSizeEnum
{
	"accessibility-font-size-default" = "Taille initiale",
	"accessibility-font-size-150" = "+&nbsp;150%",
	"accessibility-font-size-200" = "+&nbsp;200%",
}

export default AccessibilityFontSizeEnum;

